import { OnInit, Component, Optional, Inject  } from '@angular/core';
import { EventEmitterService } from '../../../../services/EventEmitterService.component';
import { MatDialog } from '@angular/material/dialog';
import { IncomeCashPopupComponent } from '../../IncomeCashPopup/IncomeCashPopup.component';
import { PershingTranslationService } from '@pershing/pershing-core';
@Component({
    selector: 'Income-Cash-Summary',
    templateUrl: './IncomeCashSummaryN.component.html',
    styleUrls: ['./IncomeCashSummary.component.css']
})
export class IncomeCashSummary implements OnInit {
    da: any[];
    Ap: any = 0;
    Ai: any = 0;
    Pi: any = 0;
    Ri: any = 0;
    Cf: any = 0;
    Tpc: any = 0;
    Total: any = 0;
    type: any = 0;
    ismobile: boolean = false;
    isAda: boolean = false;
    data: any;
    isFirst: boolean = false;
    isTpc: boolean = false;
    isTc: boolean = false;
    constructor(private eventEmitterService: EventEmitterService, private dialog: MatDialog,
                private translationService: PershingTranslationService, @Optional() @Inject('AppSettings') appSettings: any) {
                this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
                if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
                    this.ismobile = true;
                 }
                if (appSettings.themeType && appSettings.themeType === 'ada') {
                    this.isAda = true;
                }
               }
    ngOnInit() {
        if (this.eventEmitterService.subsVar === undefined) {
            this.eventEmitterService.subsVar = this.eventEmitterService.
            invokeFirstComponentFunction.subscribe((name: string) => {
              this.firstFunction();
              this.TotalProjectedCash();
              this.TotalCash();
            });
    }
}
    firstFunction() {
        this.isFirst = true;
        this.da = this.eventEmitterService.get();
        this.Ap = this.da[0];
        this.Ai = this.da[1];
        this.Pi = this.da[2];
        this.Ri = this.da[3];
        this.Cf = this.da[4];
        this.type = this.da[5];
        this.data = [this.Ap, this.Ai, this.Pi, this.Ri, this.Cf, this.type];
    }
    TotalProjectedCash() {
        this.isTpc = true;
        this.Tpc = this.Ai + this.Pi;
    }
    TotalCash() {
        this.isTc = true;
        this.Total = this.Ai + this.Pi + this.Ri + this.Cf;
    }
    popup() {
        this.dialog.open(IncomeCashPopupComponent, { disableClose: true });
    }
    popupAda() {
        this.dialog.open(IncomeCashPopupComponent);
    }

}
